import i18n from '../i18n';

export class HttpError extends Error {
  readonly status: number;
  readonly code: string | null;

  constructor(opts: { status: number; message: string; code?: string | null }) {
    super(opts.message);
    this.name = 'HttpError';
    this.status = opts.status;
    this.code = opts.code ?? null;
  }
}

export class ContractError extends Error {
  readonly issues: unknown;

  constructor(message: string, issues: unknown) {
    super(message);
    this.name = 'ContractError';
    this.issues = issues;
  }
}

export interface ErrorFields {
  readonly message: string;
  readonly code: string | null;
}

const text = (value: unknown): string | null => (typeof value === 'string' && value.length > 0 ? value : null);

export const errorFields = (data: unknown): ErrorFields => {
  const body = (data ?? {}) as Record<string, unknown>;
  return {
    message:
      text(body.message) ??
      text(body.error) ??
      i18n.t('common.somethingWentWrong', 'Something went wrong. Please try again.'),
    code: text(body.code),
  };
};

export type ErrorFactory = (status: number, data: unknown) => Error;

export const userFacingMessage = (error: unknown): string | null =>
  error instanceof HttpError && error.message.trim() !== '' ? error.message : null;

export const httpErrorFrom: ErrorFactory = (status, data) => new HttpError({ status, ...errorFields(data) });
